export default "__VITE_ASSET__c3eef237__"